/**
 * API клієнт для ref.price_groups (Порція Роздріб.2/5a).
 * Backend: /api/v1/retail/price-groups. Permissions: retail.price_groups.manage.
 */
import { api } from './client';
import type { Page } from './catalogs';

export interface PriceGroup {
  id: string;
  organization_id: string;
  code: string;
  name: string;
  description: string | null;
  is_default: boolean;
  is_active: boolean;
  sort_order: number | null;
  deletion_mark: boolean;
  created_at: string;
  created_by: string | null;
  comment: string | null;
}

export interface PriceGroupCreate {
  organization_id: string;
  code: string;
  name: string;
  description?: string | null;
  is_default?: boolean;
  is_active?: boolean;
  sort_order?: number | null;
  comment?: string | null;
}

export type PriceGroupUpdate = Partial<Omit<PriceGroupCreate, 'organization_id'>>;

export const retailPriceGroups = {
  list: (params?: { organization_id?: string; is_active?: boolean; limit?: number; offset?: number }) =>
    api.get<Page<PriceGroup>>('/retail/price-groups', { params }).then((r) => r.data),
  get: (id: string) => api.get<PriceGroup>(`/retail/price-groups/${id}`).then((r) => r.data),
  create: (payload: PriceGroupCreate) =>
    api.post<PriceGroup>('/retail/price-groups', payload).then((r) => r.data),
  update: (id: string, payload: PriceGroupUpdate) =>
    api.patch<PriceGroup>(`/retail/price-groups/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/retail/price-groups/${id}`).then(() => undefined),
};
